var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shareProduct"},[_c('van-list',{attrs:{"finished":_vm.finished,"finished-text":_vm.$t.noMoreData},on:{"load":_vm.onLoad},model:{value:(_vm.loading),callback:function ($$v) {_vm.loading=$$v},expression:"loading"}},[_c('div',{staticClass:"list"},[_c('share-list',{attrs:{"listProduct":_vm.listProduct}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }